import {createFileRoute} from '@tanstack/react-router';

import UserBackup from '@/shared/views/user/UserBackup';

export const Route = createFileRoute('/(shared)/backup')({
  component: UserBackup
});
